import { useEffect, useState } from 'react';
import PropTypes from 'prop-types'
import Zoom from '@arcgis/core/widgets/Zoom';

function MapZoomCtrl(props) {
  const [zoom, setZoom] = useState(null);
  useEffect(() => {
    if (props.view.ui.find('zoom') != null) {
      return;
    }
    const zoomWidget = new Zoom({
      id: 'zoom',
      viewModel: {
        view: props.view,
      },
      layout: props.layout,
      container: document.createElement('div'),
    });

    setZoom(zoomWidget);
    props.view.ui.add(zoomWidget, 'bottom-right');

    return function cleanup() {
      props.view.ui.remove(zoom);
    };
  }, [props.view]);
  return null;
}

MapZoomCtrl.propTypes = {
  view: PropTypes.object,
  layout: PropTypes.any
}

export default MapZoomCtrl